// src/modules/restaurant/pages/respayment/components/PaymentHeader.tsx
import React from "react";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import SecurityIcon from "@mui/icons-material/Security";

interface Props {
  getBgClass: () => string;
  themeTextColor: string;
}

const PaymentHeader: React.FC<Props> = ({ getBgClass, themeTextColor }) => (
  <div className="flex items-center gap-3 mb-1 -pt-1">
    <div className={`p-1 ${getBgClass()} rounded-xl`}>
      <PointOfSaleIcon className="text-white text-lg" />
    </div>
    <div>
      <h2 className={`text-xl font-bold`}>
        Payment Details
      </h2>
      <p className="text-gray-500 text-xs -mt-0.5 flex items-center gap-1">
        <SecurityIcon className="text-green-500 text-xs" />
        Secure & encrypted payment
      </p>
    </div>
  </div>
);

export default PaymentHeader;
